import GetFupPersonsRequestModelBase from '../_generated/modelBases/get-fup-persons-request-model-base';

export default class GetFupPersonsRequestModel extends GetFupPersonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
